import Host from '@app/store/Host';

export default function hostsToHostsById(hosts: Host[]) {
  const hostsByIds: Record<string, Host> = {};
  hosts.forEach((h) => {
    hostsByIds[h.dataLabel] = h;
  });
  return hostsByIds;
}
